import React, { createContext, useContext, useState, useEffect } from "react";

const ScoreContext = createContext();

export const ScoreProvider = ({ children }) => {
  const [scoreTable, setScoreTable] = useState(null);

  useEffect(() => {
    const grade = localStorage.getItem("grade") || "中学生";
    const table = grade === "中学生"
      ? require("./QA/scoreTable_j.js").default
      : require("./QA/scoreTable.js").default;
    setScoreTable(table);
  }, []);

  if (!scoreTable) {
    return <div>Loading...</div>;
  }

  return (
    <ScoreContext.Provider value={scoreTable}>
      {children}
    </ScoreContext.Provider>
  );
};

export const useScoreTable = () => {
  const context = useContext(ScoreContext);
  if (!context) {
    throw new Error("useScoreTable must be used within a ScoreProvider");
  }
  return context;
};
